import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  apiUrl: 'https://dev-alt-15-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-15-api.eshyft.com',
  firebaseTenantId: 'dev-alt-15-pte4s',
  adminDashboardUrl: 'https://dev-admin.eshyft.com/auth/login',
  verifyOtpUrl: 'https://verify-otp-lgtjqnr75q-uk.a.run.app'
}
